<app-attachment-uploader
    *ngIf="visible"
    [visible]="visible"
    [title]="title"
    [isViewOnly]="isViewOnly"
    [selectedAttachments]="collectionDocuments"
    [communityId]="communityId"
    [customerId]="customerId"
    [communityApiUrl]="'api/workorder/community/documents/tree'"
    [ownerApiUrl]="'api/workorder/owner/documents/tree'"
    (onAttachmentUpdate)="onAttachmentUpdate($event)"
    (onDocumentDelete)="onDeleteFile($event)"
    (onClose)="closeCollectionAttachmentSelector()"
></app-attachment-uploader>
